
// => Styling
import styles from './TagToggle.module.css';

// => Icons
import {
    IoCheckmark,
    IoClose,
    IoHeartOutline,
    IoHelpCircleOutline,
 } from "react-icons/io5";

 // => 3rd party components
import { useState } from 'react';
import { Tooltip } from 'react-tooltip';


// ============
// Component
// ============
const TagToggle = ({
    name = "",
    label = "Unnamed",
    desc = "No description.",
    allowSetOnly = true,
    onChange = (tag, value) => {},
    startValue = "none"
}) => {

    const onUpdate = (tag, value) => {
        onChange(tag, value)
        setValueText(readableValueText(value))
    }

    const readableValueText = (val = "none") => {
        let result = "Undefined"
        switch(val) {
            case "exclude":
                result = "Hide"
                break
            case "none":
                result = "Show"
                break
            case "only":
                result = "Exclusive"
                break
            default:
                break
        }
        return result
    }
    const [valueText, setValueText] = useState(readableValueText(startValue))


    // RENDER
    // ---------
    return(
        <div className={styles.container}>
            
            <fieldset className={styles.multiswitch}>
                <legend>
                    {label}
                    <span className={styles.descrIcon}
                            data-tooltip-id={name + "_tooltip"}
                            data-tooltip-place='top-start'
                            data-tooltip-offset={10}
                            data-tooltip-position-strategy='fixed'
                            data-tooltip-variant='light'>
                        <IoHelpCircleOutline />
                        {desc &&
                        <Tooltip className={styles.tooltip} id={name + "_tooltip"}>{desc}</Tooltip>}
                    </span>
                </legend>
                
                <div className={styles.slideContainer} onChange={(e)=>onUpdate(e.target.name, e.target.value)}>

                    <input type="radio" name={name} value="exclude" id={name + "_exclude"} defaultChecked={startValue === "exclude"} />
                    <label htmlFor={name + "_exclude"}><IoClose /></label>
                    <input type="radio" name={name} value="none" id={name + "_none"} defaultChecked={startValue === "none"} />
                    <label htmlFor={name + "_none"}><IoCheckmark /></label>
                    {allowSetOnly && <><input type="radio" name={name} value="only" id={name + "_only"} defaultChecked={startValue === "only"} />
                    <label htmlFor={name + "_only"}><IoHeartOutline /></label></>}

                    <span className={styles.slide} aria-hidden="true"/>
                </div>
                
                <span className={styles.valueLabel}>{valueText}</span>
            </fieldset>

        </div>
    );
}


export default TagToggle